<template>
  <div class="root">
    <div v-if="!$root.loaded" class="loading">
      <h1>Loading</h1>
      <img src="../assets/loading.gif" alt="">
    </div>
    <div v-else>
      <div class="modal" style="display:block" v-if="modalMode !== false">
        <div class="modal-background" @click="setModal(false)"></div>
        <div class="modal-content">
          <div class="modal-close" @click="setModal(false)" title="Close Window"><i class="fas fa-times"></i></div>
          <template v-if="modalMode === 'levelOfTraining'">
            <h3>Level of Training Definitions</h3>
            <span v-for="descriptor in $root.levelOfTrainingDescriptors" :key="descriptor.id">
              <p><strong>{{ descriptor.rating }}:</strong> {{ descriptor.description }}</p>
            </span>
          </template>
          <template v-if="modalMode === 'easeOfUse'">
            <h3>Ease of Use Definitions</h3>
            <span v-for="descriptor in $root.easeOfUseDescriptors" :key="descriptor.id">
              <p><strong>{{ descriptor.rating }}:</strong> {{ descriptor.description }}</p>
            </span>
          </template>
        </div>
      </div>
      <div class="kit-filter">
        <div class="kit-filter-categories">
          <div class="kit-filter-pathogen kit-filter-item">
              <div class="kit-filter-title">Pathogen:</div>
              <div class="kit-filter-input">
                <select v-model="queryParams.pathogens" v-on:change="updateQueryFilter()">
                  <option v-for="pathogens in $root.pathogens" :key="pathogens.id" :value="pathogens.id" v-show="pathogens.name">
                    {{pathogens.name}}
                  </option>
                </select>
                <span></span>
              </div>
          </div>
            <div class="kit-filter-distributor kit-filter-item">
              <div class="kit-filter-title">Distributor:</div>
              <div class="kit-filter-input">
              <select v-model="queryParams.distributor" v-on:change="updateQueryFilter()">
                <option selected value="false">Any</option>
                <option v-for="distributor in $root.distributors" :key="distributor.id" :value="distributor.id">
                  {{distributor.name}}
                </option>
              </select>
              </div>
          </div>
        </div>
        <div class="kit-filter-subcategories">
          <div class="kit-filter-usage kit-filter-item">
            <div class="kit-filter-title">Kit Usage:</div>
            <div class="kit-filter-input">
              <input type="checkbox" value="Laboratory" v-model="queryParams.laboratory" v-on:change="updateQueryFilter()"  />
              Laboratory
            </div>
            <div class="kit-filter-input">
              <input type="checkbox" value="In House"  v-model="queryParams.inHouse" v-on:change="updateQueryFilter()" />
              In House
            </div>
          </div>
          <div class="kit-filter-used-with kit-filter-item">
            <div class="kit-filter-title">Test Material:</div>
            <div class="kit-filter-input">
              <input name="environmental" type="checkbox" value="environmental" v-model="queryParams.environmental" v-on:change="updateQueryFilter()"/>
              Environmental
            </div>
            <div class="kit-filter-input">
              <input name="food" type="checkbox" value="food" v-model="queryParams.food" v-on:change="updateQueryFilter()"/>
              Food
            </div>
          </div>
            <div class="kit-filter-ease-of-use kit-filter-item">
              <div class="kit-filter-title kit-filter-title-info" @click="setModal('easeOfUse')" title="Click for Ease of Use definitions">
                Ease of Use <i class="fas fa-info-circle"></i>
              </div>
              <div class="kit-filter-input">
                <select v-model="queryParams.easeOfUse" v-on:change="updateQueryFilter()">
                  <!-- <option selected value="false">All</option> -->
                  <option value="1">{{$root.easeOfUseDescriptors[0].rating}}</option>
                  <option value="2">{{$root.easeOfUseDescriptors[0].rating}}-{{$root.easeOfUseDescriptors[1].rating}}</option>
                  <option selected value="false">{{$root.easeOfUseDescriptors[0].rating}}-{{$root.easeOfUseDescriptors[2].rating}}</option>
                </select>
              </div>
            <!-- <div class="kit-filter-input">
              <input type="radio" name="radio-ease-of-use" value="false" v-model="queryParams.easeOfUse" v-on:change="updateQueryFilter()"  />
              All
            </div>
            <div class="kit-filter-input">
              <input type="radio" name="radio-ease-of-use" value="1" v-model="queryParams.easeOfUse" v-on:change="updateQueryFilter()"  />
              Easy
            </div>
            <div class="kit-filter-input">
              <input type="radio" name="radio-ease-of-use" value="2" v-model="queryParams.easeOfUse" v-on:change="updateQueryFilter()"  />
              Easy-Medium
            </div>
            <div class="kit-filter-input">
              <input type="radio" name="radio-ease-of-use" value="3" v-model="queryParams.easeOfUse" v-on:change="updateQueryFilter()" />
              Easy-Harder
            </div> -->
          </div>
          <div class="kit-filter-level-of-training kit-filter-item">
            <div class="kit-filter-title kit-filter-title-info" @click="setModal('levelOfTraining')" title="Click for Level of Training definitions">
              Level of Training <i class="fas fa-info-circle"></i>
            </div>
            <div class="kit-filter-input">
            <select v-model="queryParams.levelOfTraining" v-on:change="updateQueryFilter()">
              <!-- <option selected value="false">All</option> -->
              <option value="1">{{$root.levelOfTrainingDescriptors[0].rating}}</option>
              <option value="2">{{$root.levelOfTrainingDescriptors[0].rating}}-{{$root.levelOfTrainingDescriptors[1].rating}}</option>
              <option selected value="false">{{$root.levelOfTrainingDescriptors[0].rating}}-{{$root.levelOfTrainingDescriptors[2].rating}}</option>
            </select>
            </div>
          </div>
        </div>
        <div class="kit-filter-comparisons">
          <div class="kit-filter-item">
            <div class="selected-comparisons" v-for="kit in compareKits" :key="kit" @click="compareKit(kit)">
              {{  getKitName(kit) }}
              <span class="comparison-remove">&#x2715;</span>
            </div>
            <button class="compare-button" v-if="compareKits.length > 1" @click="navigateToKitCompare">Compare kits</button>
          </div>
        </div>
      </div>

      <div class="kit-results three">
        <div v-for="filteredKit in filteredKits" :key="filteredKit.id" class="kit-result" @click.stop="navigateToKitDetails(filteredKit.id)">
          <div
            class="add-comparison"
            :class="[compareKits.includes(filteredKit.id) ? 'remove' : '', compareKits.length < 3 ? '' : 'disabled']"
            @click.stop="compareKit(filteredKit.id)">
            Compare
          </div>
          <div class="kit-result-title">{{ filteredKit.name.trim() }}</div>
          <ul>
            <li v-if="filteredKit.website">
              <a :href="filteredKit.website" target="_blank" @click.stop>Website</a>
            </li>
            <li>
              <a v-if="filteredKit.instructions" :href="filteredKit.instructions" target="_blank" @click.stop>Instructions</a>
              <a v-else :href="filteredKit.distributorInfo.website" target="_blank" @click.stop>Please Contact Distributor for Instructions</a>
            </li>
            <li v-if="filteredKit.turnaroundTime">
              Turn Around: {{ filteredKit.turnaroundTime }}
            </li>
            <li v-if="filteredKit.kitValidationStandards">
              <span v-for="standard in filteredKit.kitValidationStandards" :key="standard.id">
                Kit Validation: {{ standard.name }}
              </span>
            </li>
            <li v-if="filteredKit.detectionLimits">
              Detection Limits: {{filteredKit.detectionLimits[0].name}}
            </li>
            <li v-if="filteredKit.easeOfUse">
              Ease of Use:
              <span>{{$root.easeOfUseDescriptors[filteredKit.easeOfUse - 1].rating}}</span>
            </li>
            <li v-if="filteredKit.levelOfTraining">
              Level of Training:
              <span>{{$root.levelOfTrainingDescriptors[filteredKit.levelOfTraining - 1].rating}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KitFilter',
  data () {
    return {
      queryParams: {
        pathogens: null,
        distributor: null,
        laboratory: null,
        inHouse: null,
        environmental: null,
        food: null,
        easeOfUse: false,
        levelOfTraining: false
      },
      kitFilters: [],
      materialFilters: [],
      compareKits: this.$root.compareKits,
      modalMode: false
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.setData()
    // this.updateQueryFilter()
  },
  computed: {
    filteredKits () {
      if (this.$root.loaded) {
        var lcFilteredKits = []
        var filterQuery = this.queryParams
        var filterArray = []

        // Pushes all true filters to array
        Object.keys(filterQuery).forEach(filter => {
          if (filterQuery[filter] !== false && filterQuery[filter] !== null && filter !== 'time') {
            filterArray.push(filter)
          }
        })

        // If available kits & active filters
        if (this.$root.kits.length > 0 && filterArray.length > 0) {
        // Loop kits
          this.$root.kits.forEach(kit => {
          // Loop filters and return true if kit matches all active filters
            var isMatch = filterArray.every(filter => {
              // laboratory OR in house
              if (filter === 'laboratory' || filter === 'inHouse') {
                if (this.kitFilters.length === 2) {
                  return true
                }
              }

              if (filter === 'environmental' || filter === 'food') {
                if (this.materialFilters.length === 2) {
                  return true
                }
              }

              if (filter === 'easeOfUse') {
                if (kit.easeOfUse <= this.queryParams.easeOfUse) {
                  return true
                }
              }

              if (filter === 'levelOfTraining') {
                if (kit.levelOfTraining <= this.queryParams.levelOfTraining) {
                  return true
                }
              }

              // If kit filter propery is array find id match
              if (Array.isArray(kit[filter])) {
                var itemMatch = kit[filter].some(qItem => {
                  if (qItem === filterQuery[filter]) {
                    return true
                  } else {
                    return false
                  }
                })
                return itemMatch
              } else {
                if (kit[filter] === filterQuery[filter]) {
                  return true
                } else {
                  return false
                }
              }
            })
            // If match push kit
            if (isMatch === true) {
              lcFilteredKits.push(kit)
            }
          })
          return lcFilteredKits
        // No active filters return root data
        } else {
          return this.$root.kits
        }
      } else {
        return []
      }
    }
  },
  methods: {
    setModal (mode) {
      this.modalMode = mode
    },
    getParamName (index) {
      var name = ''
      if (index === 0) {
        name = 'pathogens'
      } else if (index === 1) {
        name = 'distributor'
      } else if (index === 2) {
        name = 'laboratory'
        if (this.queryParams[name] === true) {
          this.kitFilters.push(name)
        }
      } else if (index === 3) {
        name = 'inHouse'
        if (this.queryParams[name] === true) {
          this.kitFilters.push(name)
        }
      } else if (index === 4) {
        name = 'environmental'
        if (this.queryParams[name] === true) {
          this.materialFilters.push(name)
        }
      } else if (index === 5) {
        name = 'food'
        if (this.queryParams[name] === true) {
          this.materialFilters.push(name)
        }
      } else if (index === 6) {
        name = 'easeOfUse'
      } else if (index === 7) {
        name = 'levelOfTraining'
      }
      return name
    },
    updateQueryFilter () {
      this.kitFilters = []
      this.materialFilters = []
      var data = [
        this.queryParams.pathogens,
        this.queryParams.distributor,
        this.queryParams.laboratory,
        this.queryParams.inHouse,
        this.queryParams.environmental,
        this.queryParams.food,
        this.queryParams.easeOfUse,
        this.queryParams.levelOfTraining
      ]

      var queryObj = {
        time: Date.now()
      }

      for (let i = 0; i < data.length; i++) {
        const name = this.getParamName(i)
        if (data[i] !== null) {
          if (data[i] === 'true') {
            queryObj[name] = true
          } else if (data[i] === 'false' || data[i] === '') {
            queryObj[name] = false
          } else {
            queryObj[name] = data[i]
          }
        }
      }

      this.$router.push({ query: Object.assign({}, this.$route.query, queryObj) }).catch(err => {
        console.log(err)
      })
    },
    setData () {
      this.queryParams = {
        pathogens: 'recjxxCKJJcq5MFEc',
        distributor: false,
        laboratory: true,
        inHouse: true,
        environmental: true,
        food: true,
        easeOfUse: false,
        levelOfTraining: false
      }
      if (this.$route.query) {
        Object.keys(this.$route.query).forEach(filterQuery => {
          if (this.$route.query[filterQuery] === 'true') {
            this.queryParams[filterQuery] = true
          } else if (this.$route.query[filterQuery] === 'false') {
            this.queryParams[filterQuery] = false
          } else {
            this.queryParams[filterQuery] = this.$route.query[filterQuery]
          }
        })
      }
    },
    compareKit (id) {
      var added = this.$root.compareKits.includes(id)
      if (!added && this.$root.compareKits.length !== 3) {
        this.$root.compareKits.push(id)
      }

      if (added) {
        var index = this.$root.compareKits.findIndex(kit => kit === id)
        this.$root.compareKits.splice(index, 1)
      }
    },
    getKitName (kit) {
      var kitName = this.$root.kits.find(fk => fk.id === kit).name.trim()
      if (kitName.length > 20) {
        kitName = kitName.substring(0, 20) + ' ...'
      }
      return kitName
    },
    navigateToKitDetails (id) {
      this.$router.push(`/details?id=${id}`)
    },
    navigateToKitCompare () {
      this.$router.push(`/compare?kits=${this.compareKits.join('-')}`)
    }
  },
  watch: {
    $route (to, from) {
      this.setData()
    }
  }
}
</script>
